import { Link, WithRouterProps, withRouter } from 'react-router';
import {
  navMenuItemNotificationBadge,
  navMenuItemRecipe,
  tabletHideClass,
} from './navMenu.css';
import { Typography } from '../typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { trackSessionEvent } from '@services/session-tracker/sessionTracker';
import { mixTrack } from '@services/mixpanel';

export type NavMenuItemProps = {
  caption: string | React.ReactNode;
  to: string;
  icon: IconProp;
  subPaths?: string[];
  externalLink?: boolean;
  notificationCount?: number;
  testId?: string;
};

const getIsActive = (p: NavMenuItemProps & Partial<WithRouterProps>) => {
  const path = p.location?.pathname ?? '';
  const isActive =
    p.to === path ||
    `/${path}` === p.to ||
    p.subPaths?.some((i) => path.startsWith(i) || `/${path}`.startsWith(i));

  return Boolean(isActive);
};

const NavMenuItemRaw = ({
  testId,
  ...p
}: NavMenuItemProps & Partial<WithRouterProps>) => {
  const onClick = () => {
    if (testId) trackSessionEvent('LinkClick', { testId, to: p.to });
    mixTrack({
      type: 'Main Menu Item Tapped',
      payload: {
        'Main Menu Item': typeof p.caption === 'string' ? p.caption : undefined,
      },
    });
  };

  return (
    <Link
      role="listitem"
      to={p.externalLink ? '' : p.to}
      href={p.externalLink ? p.to : undefined}
      target={p.externalLink ? '_blank' : undefined}
      className={navMenuItemRecipe({ isActive: getIsActive(p) })}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={p.icon} width={26} height={24} />
      <Typography
        variant="body"
        size="large"
        as="span"
        className={tabletHideClass}
      >
        {p.caption}
      </Typography>
      {p.notificationCount ? (
        <span className={navMenuItemNotificationBadge}>
          <Typography
            variant="body"
            size="small"
            color="W-100"
            className={tabletHideClass}
          >
            {p.notificationCount}
          </Typography>
        </span>
      ) : null}
    </Link>
  );
};

export const NavMenuItem = withRouter(NavMenuItemRaw);
